import { render, staticRenderFns } from "./AmlExpedia.vue?vue&type=template&id=7084b6c3&scoped=true"
import script from "./AmlExpedia.vue?vue&type=script&lang=js"
export * from "./AmlExpedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084b6c3",
  null
  
)

export default component.exports